/*************************************************/
/* Vue                                           */
/*************************************************/
import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import VehiclesSortedSet from './vue/vehiclesSortedSet.vue';
import ToastService from 'primevue/toastservice';
import PrimevueLocale  from './vue/primevueLocale';

const vehicleSortedSetSelector = ".vehicles-slider_app";
const vehicleSortedSetElements = document.querySelectorAll(vehicleSortedSetSelector);
if (vehicleSortedSetElements) {
    vehicleSortedSetElements.forEach(element => {
        const vehicleNodeId = element.dataset.vehicleNodeId;
        const sortBy = element.dataset.sortBy;
        const productId = element.dataset.productId;
        const productVariantId = element.dataset.productVariantId;
        const componentId = element.dataset.componentId;
        const take = parseInt(element.dataset.take);
        const isSlider = element.dataset.isSlider == "True";
    
        const seedData = {
            vehicleNodeId:vehicleNodeId,
            sortBy:sortBy,
            take:take,
            productId:productId,
            productVariantId:productVariantId,
            isSlider:isSlider,
            componentId:componentId
        };
    
        const vehiclesSortedSet = createApp({
            data() { return seedData },
            render: () => h(VehiclesSortedSet)
        }, seedData);
    
        vehiclesSortedSet.use(ToastService);
        vehiclesSortedSet.use(PrimeVue,{
            locale:PrimevueLocale.locale
        });
    
        vehiclesSortedSet.mount(element);
    });

    
}